import { VStack, Box } from "@chakra-ui/layout"
import React, { useMemo } from "react"
import { Control, Controller } from "react-hook-form"

import { GetAuthRegister } from "~/api/auth/register/get"
import Input from "~/components/atoms/Input"
import RadioButton from "~/components/atoms/RadioButton"
import Selectbox from "~/components/atoms/Selectbox"
import Typography from "~/components/atoms/Typography"
import { FormContainer } from "~/components/molecules/FormContainer"
import { SpacingSize } from "~/consts/style-mixins"
import { createOptions, Option } from "~/services/createOptions"

import { Section } from "../components/Section"
import { LABELS, VALIDATE_MAP } from "../constants"
import { HackedPostAuthRegisterBody } from "../types"

type Props = {
  control: Control<HackedPostAuthRegisterBody>
  formMasterData: GetAuthRegister
}

/**
 * 202211 登録フォーム改修にて作成。
 * 必須入力を減らす為、BasicInfoで実装していた項目をAdditionalProfileに移設しすべて任意項目とする
 */
export const AdditionalProfile: React.VFC<Props> = ({ control, formMasterData }) => {
  const {
    register,
    _formState: { errors },
  } = control

  const options = useMemo(() => {
    const graduationYears = formMasterData.graduation_years || []
    let graduatesInOptions = graduationYears.map((y): Option => ({ text: `${y}年卒`, value: `${y}` }))
    return {
      graduatesIn: createOptions(graduatesInOptions, { isAddInitialOption: true }),
    }
  }, [formMasterData])

  return (
    <Section title="追加プロフィール情報">
      <VStack spacing={SpacingSize._2XL}>
        <FormContainer label={LABELS.phoneNumber} errorMessage={errors.phone_number?.message}>
          <Input
            {...register("phone_number", { validate: VALIDATE_MAP.phone_number })}
            placeholder="09012345678"
            autoComplete="tel"
            isError={!!errors.phone_number}
          />
          <Box mt={SpacingSize.XS}>
            <Typography type="SubNote">
              ※インターンや就活サポートのため、アドバイザーからご連絡する場合があります
            </Typography>
          </Box>
        </FormContainer>

        <FormContainer label={LABELS.graduatesIn} errorMessage={errors.graduates_in?.message}>
          <Selectbox
            options={options.graduatesIn ?? []}
            selectProps={register("graduates_in", { valueAsNumber: true })}
            isError={!!errors.graduates_in}
          />
        </FormContainer>

        <FormContainer label={LABELS.sex} errorMessage={errors.sex?.message}>
          <Controller
            name="sex"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <RadioButton
                columnNumber={3}
                items={[
                  { text: "男性", value: "男性" },
                  { text: "女性", value: "女性" },
                  { text: "その他", value: "その他" },
                ]}
                value={value}
                onChange={onChange}
                isError={!!error}
              />
            )}
          />
        </FormContainer>
      </VStack>
    </Section>
  )
}
